<template>
  <div class="prescriptionGoodsCon">
    <lk-form :label-width="84">
      <lk-row :gutter='16'  style="width: 166.66%">
        <lk-col span='50'>
          <lk-form-item label="处方商品:" >
            <lk-button
              v-if="able"
              type="primary"
              @click="handleClick"
              >编辑处方商品</lk-button
            >
          </lk-form-item>
          <lk-table border :columns="columns" :data="tempTableData"></lk-table>
        </lk-col>
      </lk-row>
    </lk-form>
    <prescription-goods-modal
      v-model="goodsModal"
      :able='visiableAble'
      :tableData='prescriptionGoods'
      @setSelected='setSelected'
    ></prescription-goods-modal>
  </div>
</template>
<script>
import goods from '../../services/goods'
import utils from '../../libs/utils'
import NumberInput from '../sale/NumberInput.vue';

import prescriptionGoodsModal from '../../components/prescription/PrescriptionGoodsModal.vue';

export default {
  name: 'PrescriptionGoods',
  components: {
    NumberInput,
    prescriptionGoodsModal,
  },
  props: {
    drugTableData: {
      type: Array,
      default: () => [],
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    tempTable: {
      type: Array,
      default: () => [],
    },
    usageList: {
      type: Array,
      default: () => [],
    },
    able: {
      type: Boolean,
      default: true,
    },
  },
  model: {
    event: 'change',
    prop: 'drugTableData',
  },
  computed: {
  },
  watch: {
    drugTableData: {
      handler(val) {
        const tempIds = this.tempTableData.map(item => item.goodsBaseId);
        const drugIds = Array.from(new Set(this.drugTableData.map(item => item.goodsBaseId)));
        // 删除操作
        this.handleDelectDrug(tempIds, drugIds);
        // prescriptionGoods   编辑处方商品table
        // tempTableData   编辑处方商品下面所选table
        this.drugTableData.forEach(item => {
          const ids = this.prescriptionGoods.map(item => item.goodsBaseId);
          const tempTableDataids = this.tempTableData.map(item => item.goodsBaseId);
          if (ids.indexOf(item.goodsBaseId) === -1) {
            const result = utils.deepClone(item);
            !result.approvedDrugNames ? result.approvedDrugNames = result.approvedName : null;
            !result.approvedName ? result.approvedName = result.approvedDrugNames : null;
            result.specifications = result.spec;
            !result.drugSerialCode ?  result.drugSerialCode = result.serialCode : null;
            result._disabled = result.isRx === 1;
            result._checked = result.isRx === 1;
            this.tempTableData.forEach((subItem) => {
            if (subItem.goodsBaseId === result.goodsBaseId) {
              result._checked = true;
            }
          });
            this.prescriptionGoods.push(result);
            if (result.isRx === 1 && tempTableDataids.indexOf(result.goodsBaseId) === -1) {
              this.tempTableData.push(result);
            }
          }
        })
        this.handlerPurchaseNum(drugIds);
        // purchaseNum 计算出商品数量
        // 数量变化时更新
        this.tempTableData.forEach((item, index) => {
          this.purchaseNum.forEach(subItem => {
            if (item.goodsBaseId === subItem.id) {
              this.$set(item, 'num', subItem.purchaseNum)
              item.num = subItem.purchaseNum;
            }
          })
        });
        this.prescriptionGoods.forEach(item => {
          this.tempTableData.forEach( subItem => {
            if (item.goodsBaseId === subItem.goodsBaseId) {
              item._checked = true;
            }
          })
        })
      },
      deep: true,
    },
    usageList: {
      handler(val) {
        this.tempTableData = this.usageList;
      },
      deep: true,
    },
    tempTable: {
      handler(val) {
        this.tempTableData = this.tempTable;
      }
    },
  },
  data() {
    return {
      valid: false,
      electronicPrescriptionUsage: [], // 处方商品
      prescriptionGoods: [], // 编辑处方信息
      goodsModal: false,
      purchaseNum: [],
      idList: [],
      visiableAble: false, // 视图变化是否出发弹窗
      tempTableData: [],
      baseData: {
        usageArr: [],
        frequencyArr: [],
      }, // 用法用量
      columns: [
        {
          title: '商品通用名',
          key: 'approvedDrugNames',
          minWidth: 116,
        },
        {
          title: '商品名',
          key: 'goodsName',
          minWidth: 116,
        },
        {
          title: '规格',
          key: 'spec',
          minWidth: 116
        },
        {
          title: '数量',
          key: 'num',
          minWidth: 144,
        },
        {
          title: '用法',
          key: 'usageType',
          minWidth: 144,
          render: (h, params) => {
            const optionArr = this.baseData.usageArr.map(item => h('lk-option', {
              props: {
                value: item.dictionaryIndex,
              },
            }, item.dictionaryName));
            return this.able ? h('lk-select',
              {
                props: {
                  value: params.row.usageType || '',
                  placeholder: '请选择',
                  transfer: true,
                },
                on: {
                  'on-change': (value) => {
                    this.handlerChange(params.index,'usageType',value);
                  },
                },
              },
            optionArr) : h('span', params.row.usageName)
          },
        },
        {
          title: '频次',
          key: 'frequency',
          minWidth: 144,
          render: (h, params) => {
            const optionArr = this.baseData.frequencyArr.map(item => h('lk-option', {
              props: {
                value: item.dictionaryIndex,
              },
            }, item.dictionaryName));
            return this.able ? h('lk-select',
              {
                props: {
                  value: params.row.frequency || '',
                  placeholder: '请选择',
                  transfer: true,
                },
                on: {
                  'on-change': (value) => {
                    this.handlerChange(params.index,'frequency',value);
                  },
                },
              },
            optionArr) : h('span', params.row.frequencyName);
          },
        },
        {
          title: '每次用量',
          key: 'dosage',
          minWidth: 144,
          render: (h, params) => {
            return this.able ? h('lk-input',
              {
                props: {
                  value: params.row.dosage || '',
                  placeholder: '',
                  maxlength: 20,
                },
                on: {
                  'on-blur': (e) => {
                    this.handlerChange(params.index,'dosage',e.target.value);
                  },
                },
              }) : h('span', params.row.dosage);
          },
        },
        {
          title: '开始用药时间',
          key: 'startTime',
          minWidth: 144,
          render: (h, params) => this.able ? h('timeStampDatePicker', {
            on: {
              'on-change': (value) => {
                this.handlerChange(params.index,'startTime',value);
              },
            },
            props: {
              value:  params.row.startTime || '',
            },
          }) : h('span', utils.formatDate(params.row.startTime)),
        },
        {
          title: '用药周期',
          key: 'usageCycle',
          minWidth: 144,
          render: (h, params) => this.able ? h(NumberInput, {
            on: {
              'on-blur': (e) => {
                let usageCycle = e;
                if (usageCycle < params.row.remindDays) {
                  this.$Message.error('用药周期不能小于提醒天数');
                  usageCycle = '';
                }
                this.handlerChange(params.index,'usageCycle', usageCycle);
              },
            },
            props: {
              type: 'int',
              maxlength: 9,
              value: params.row.usageCycle || '',
            },
          }) : h('span', params.row.usageCycle),
        },
        {
          title: '用药提醒天数',
          key: 'remindDays',
          minWidth: 144,
          render: (h, params) => this.able ? h(NumberInput, {
            on: {
              'on-blur': (e) => {
                let remindDays = e;
                if (remindDays > params.row.usageCycle) {
                  this.$Message.error('用药周期不能小于提醒天数');
                  remindDays = '';
                }
                this.handlerChange(params.index,'remindDays',remindDays);
              },
            },
            props: {
              type: 'int',
              maxlength: 9,
              value: params.row.remindDays || '',
            },
          }) : h('span', params.row.remindDays),
        },
      ],
    }
  },
  methods: {
    exchangeDictionary(arr, index) {
      return utils.exchangeDictionary(arr, index);
    },
    handlerChange(index, str, val) {
      switch(str) {
        case 'frequency':
        this.$set(this.tempTableData[index],'frequencyName', this.exchangeDictionary(this.baseData.frequencyArr, val));
        break;
        case 'usageType':
        this.$set(this.tempTableData[index],'usageName', this.exchangeDictionary(this.baseData.usageArr, val));
        break;
        default:
        break;
      }
      this.$set(this.tempTableData[index],str, val);
    },
    validateForm() {
      // isPatientRebuy  复购药
      this.$store.commit('setTableData', this.tempTableData);
      return new Promise((resolve) => {
        this.valid = true;
        this.tempTableData.forEach(item => {
         // 判断复购药
          if (item.isPatientRebuy && (!item.startTime || !item.remindDays || !item.usageCycle)) {
            this.$Message.error(`请在${item.approvedName || itme.approvedDrugNames.join('、')}的商品行填写开始用药时间，用药周期和用药提醒天数`);
            this.valid = false;
          }
        })
        resolve(this.valid)
      });
    },
    handleClick() {
      this.goodsModal = true;
    },
    setSelected(list) {
      this.goodsModal = false;
      // 全选之后再次添加处方返回的还是第一次选择的，遍历一下编辑处方商品的tableData，如果都是处方商品return；
      // isRx 1 为处方药， 2 为非处方药
      const isRx = this.prescriptionGoods.map(item => item.isRx);
      if(isRx.indexOf(2) === -1) return;   // 为了解决 第一次点了全选之后，再次添加商品后编辑处方点击确定后会置空
      // 根据goodsBaseId来判断是增加了还是减少了
      this.idList = list.map(item => item.goodsBaseId);
      if (this.idList.length > 0) {
        const ids = this.tempTableData.map(item => item.goodsBaseId);
        let newIds = [];
        if (this.idList.length > ids.length) {
          newIds = this.idList.filter((x) => !ids.some(y => x === y));
          if (newIds.length > 0) {
            newIds.forEach(id => {
              let num = 0;
              this.drugTableData.forEach(subItem => {
                const temp = utils.deepClone(subItem);
                if (id === temp.goodsBaseId) {
                  num = num + Number(temp.purchaseNum);
                }
              })
              const tempTableDataIds = this.tempTableData.map(item => item.goodsBaseId);
              if (tempTableDataIds.indexOf(id) === -1) {
                const result = this.drugTableData.find(item => item.goodsBaseId === id);
                let temp =  utils.deepClone(result)
                !temp.approvedName ? temp.approvedName = temp.approvedDrugNames : null;
                this.$set(temp, 'num', num);
                this.tempTableData.push(temp);
              }
            })
          }
        } else {
          newIds = ids.filter((x) => !this.idList.some(y => x === y));
          if (newIds.length > 0) {
            newIds.forEach(id => {
              this.tempTableData.forEach((item, index) => {
                if (item.goodsBaseId === id) {
                  this.tempTableData.splice(index, 1);
                }
              })
            })
          }
        }
      } else {
        this.tempTableData = [];
      }
    },
    handleDelectDrug(tempIds, drugIds) {
      // 怎么判断删除那？ 编辑的id和所选药的id数量不一样时
      const prescriptionId = this.prescriptionGoods.map(item => item.goodsBaseId);
      const delectIds = prescriptionId.filter((x) => !drugIds.some(y => x === y));
      if (delectIds.length > 0) {
        const tempPrescriptionIdx = this.prescriptionGoods.findIndex(item => item.goodsBaseId === delectIds[0]);
        this.prescriptionGoods.splice(tempPrescriptionIdx, 1);
        if (tempIds.indexOf(delectIds[0]) !== -1) {
          const tempIdx = this.tempTableData.findIndex(item => item.goodsBaseId === delectIds[0]);
          this.tempTableData.splice(tempIdx, 1);
        }
      }
    },
    // 计算购买数量
    handlerPurchaseNum(drugIds) {
      drugIds.forEach(id => {
          const purchaseNumIds = this.purchaseNum.map(item => item.id)
          if (purchaseNumIds.indexOf(id) === -1) {
            this.purchaseNum.push({
              id,
              purchaseNum: 1,
            })
          }
          var purchaseNum = 0;
          this.drugTableData.forEach(item => {
            if (id === item.goodsBaseId) {
              purchaseNum = purchaseNum + Number(item.purchaseNum);
            }
          })
          this.purchaseNum.forEach(item => {
            if (item.id === id) {
              item.purchaseNum = purchaseNum;
            }
          })
        });
    },
    getBaseData() {  // 获取用法用量
      goods.GoodsDictionary().then((res) => {
        if (res.data.status === 200) {
          this.baseData.usageArr = [];
          this.baseData.frequencyArr = [];
          res.data.data.forEach((item) => {
            switch (item.dictionaryType) {
              case 14:
                this.baseData.usageArr.push(item);
                break;
              case 15:
                this.baseData.frequencyArr.push(item);
                break;

              default:
                break;
            }
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
    this.getBaseData();

  },
};
</script>
<style lang="less" scoped>
.prescriptionGoodsCon {
  thead {
    /deep/ .ivu-checkbox {
      display: none !important;
    }
  }
  /deep/ .ivu-input-small {
    height: 32px;
  }
}
</style>
